/*
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */
// prettier-ignore
!function(e,i){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("jquery")):e.jQueryBridget=i(e,e.jQuery)}(window,function(t,e){"use strict";var i=Array.prototype.slice,n=t.console,d=void 0===n?function(){}:function(t){n.error(t)};function s(h,s,c){(c=c||e||t.jQuery)&&(s.prototype.option||(s.prototype.option=function(t){c.isPlainObject(t)&&(this.options=c.extend(!0,this.options,t))}),c.fn[h]=function(t){return"string"==typeof t?function(t,o,r){var a,l="$()."+h+'("'+o+'")';return t.each(function(t,e){var i=c.data(e,h);if(i){var n=i[o];if(n&&"_"!=o.charAt(0)){var s=n.apply(i,r);a=void 0===a?s:a}else d(l+" is not a valid method")}else d(h+" not initialized. Cannot call methods, i.e. "+l)}),void 0!==a?a:t}(this,t,i.call(arguments,1)):(function(t,n){t.each(function(t,e){var i=c.data(e,h);i?(i.option(n),i._init()):(i=new s(e,n),c.data(e,h,i))})}(this,t),this)},o(c))}function o(t){!t||t&&t.bridget||(t.bridget=s)}return o(e||t.jQuery),s}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],s=0;s<i.length;s++){var o=i[s];n&&n[o]&&(this.off(t,o),delete n[o]),o.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function m(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}var i="undefined"==typeof console?function(){}:function(t){console.error(t)},y=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],b=y.length;function E(t){var e=getComputedStyle(t);return e||i("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}var S,C=!1;function x(t){if(function(){if(!C){C=!0;var t=document.createElement("div");t.style.width="200px",t.style.padding="1px 2px 3px 4px",t.style.borderStyle="solid",t.style.borderWidth="1px 2px 3px 4px",t.style.boxSizing="border-box";var e=document.body||document.documentElement;e.appendChild(t);var i=E(t);S=200==Math.round(m(i.width)),x.isBoxSizeOuter=S,e.removeChild(t)}}(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var e=E(t);if("none"==e.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<b;e++){t[y[e]]=0}return t}();var i={};i.width=t.offsetWidth,i.height=t.offsetHeight;for(var n=i.isBorderBox="border-box"==e.boxSizing,s=0;s<b;s++){var o=y[s],r=e[o],a=parseFloat(r);i[o]=isNaN(a)?0:a}var l=i.paddingLeft+i.paddingRight,h=i.paddingTop+i.paddingBottom,c=i.marginLeft+i.marginRight,d=i.marginTop+i.marginBottom,u=i.borderLeftWidth+i.borderRightWidth,f=i.borderTopWidth+i.borderBottomWidth,p=n&&S,g=m(e.width);!1!==g&&(i.width=g+(p?0:l+u));var v=m(e.height);return!1!==v&&(i.height=v+(p?0:h+f)),i.innerWidth=i.width-(l+u),i.innerHeight=i.height-(h+f),i.outerWidth=i.width+c,i.outerHeight=i.height+d,i}}return x}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var i=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i]+"MatchesSelector";if(t[n])return n}}();return function(t,e){return t[i](e)}}),function(e,i){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("desandro-matches-selector")):e.fizzyUIUtils=i(e,e.matchesSelector)}(window,function(h,o){var c={extend:function(t,e){for(var i in e)t[i]=e[i];return t},modulo:function(t,e){return(t%e+e)%e}},e=Array.prototype.slice;c.makeArray=function(t){return Array.isArray(t)?t:null==t?[]:"object"==typeof t&&"number"==typeof t.length?e.call(t):[t]},c.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},c.getParent=function(t,e){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,o(t,e))return t},c.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},c.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},c.filterFindElements=function(t,n){t=c.makeArray(t);var s=[];return t.forEach(function(t){if(t instanceof HTMLElement)if(n){o(t,n)&&s.push(t);for(var e=t.querySelectorAll(n),i=0;i<e.length;i++)s.push(e[i])}else s.push(t)}),s},c.debounceMethod=function(t,e,n){n=n||100;var s=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,i=this;this[o]=setTimeout(function(){s.apply(i,e),delete i[o]},n)}},c.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},c.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var d=h.console;return c.htmlInit=function(a,l){c.docReady(function(){var t=c.toDashed(l),s="data-"+t,e=document.querySelectorAll("["+s+"]"),i=document.querySelectorAll(".js-"+t),n=c.makeArray(e).concat(c.makeArray(i)),o=s+"-options",r=h.jQuery;n.forEach(function(e){var t,i=e.getAttribute(s)||e.getAttribute(o);try{t=i&&JSON.parse(i)}catch(t){return void(d&&d.error("Error parsing "+s+" on "+e.className+": "+t))}var n=new a(e,t);r&&r.data(e,l,n)})})},c}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("get-size")):(e.Flickity=e.Flickity||{},e.Flickity.Cell=i(e,e.getSize))}(window,function(t,e){function i(t,e){this.element=t,this.parent=e,this.create()}var n=i.prototype;return n.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-hidden","true"),this.x=0,this.shift=0},n.destroy=function(){this.unselect(),this.element.style.position="";var t=this.parent.originSide;this.element.style[t]=""},n.getSize=function(){this.size=e(this.element)},n.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},n.updateTarget=n.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},n.renderPosition=function(t){var e=this.parent.originSide;this.element.style[e]=this.parent.getPositionValue(t)},n.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},n.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},n.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},n.remove=function(){this.element.parentNode.removeChild(this.element)},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/slide",e):"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}(window,function(){"use strict";function t(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var e=t.prototype;return e.addCell=function(t){if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},e.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.cells.forEach(function(t){t.select()})},e.unselect=function(){this.cells.forEach(function(t){t.unselect()})},e.getCellElements=function(){return this.cells.map(function(t){return t.element})},t}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("fizzy-ui-utils")):(e.Flickity=e.Flickity||{},e.Flickity.animatePrototype=i(e,e.fizzyUIUtils))}(window,function(t,e){var i={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;requestAnimationFrame(function(){e.animate()})}},positionSlider:function(){var t=this.x;this.options.wrapAround&&1<this.cells.length&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),this.setTranslateX(t,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,t=this.options.rightToLeft?-t:t;var i=this.getPositionValue(t);this.slider.style.transform=e?"translate3d("+i+",0,0)":"translateX("+i+")"},dispatchScrollEvent:function(){var t=this.slides[0];if(t){var e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])}},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){this.isPointerDown||Math.round(100*this.x)!=Math.round(100*t)||this.restingFrames++,2<this.restingFrames&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){for(var n=0;n<t.length;n++){var s=t[n],o=0<e?i:0;s.wrapShift(o),e-=s.size.outerWidth}},_unshiftCells:function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(this.isDraggable&&this.isPointerDown){var t=this.dragX-this.x-this.velocity;this.applyForce(t)}},applySelectedAttraction:function(){if(!(this.isDraggable&&this.isPointerDown)&&!this.isFreeScrolling&&this.slides.length){var t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}}};return i}),function(r,a){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],function(t,e,i,n,s,o){return a(r,t,e,i,n,s,o)});else if("object"==typeof module&&module.exports)module.exports=a(r,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var t=r.Flickity;r.Flickity=a(r,r.EvEmitter,r.getSize,r.fizzyUIUtils,t.Cell,t.Slide,t.animatePrototype)}}(window,function(n,t,e,a,i,r,s){var l=n.jQuery,o=n.getComputedStyle,h=n.console;function c(t,e){for(t=a.makeArray(t);t.length;)e.appendChild(t.shift())}var d=0,u={};function f(t,e){var i=a.getQueryElement(t);if(i){if(this.element=i,this.element.flickityGUID){var n=u[this.element.flickityGUID];return n.option(e),n}l&&(this.$element=l(this.element)),this.options=a.extend({},this.constructor.defaults),this.option(e),this._create()}else h&&h.error("Bad element for Flickity: "+(i||t))}f.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},f.createMethods=[];var p=f.prototype;a.extend(p,t.prototype),p._create=function(){var t=this.guid=++d;for(var e in this.element.flickityGUID=t,(u[t]=this).selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&n.addEventListener("resize",this),this.options.on){var i=this.options.on[e];this.on(e,i)}f.createMethods.forEach(function(t){this[t]()},this),this.options.watchCSS?this.watchCSS():this.activate()},p.option=function(t){a.extend(this.options,t)},p.activate=function(){this.isActive||(this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize(),c(this._filterFindCellElements(this.element.children),this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent("ready"))},p._createSlider=function(){var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},p._filterFindCellElements=function(t){return a.filterFindElements(t,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},p._makeCells=function(t){return this._filterFindCellElements(t).map(function(t){return new i(t,this)},this)},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(t){t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;var e=0;if(0<t){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,s=t;s<n;s++){var o=this.cells[s];o.setPosition(e),e+=o.size.outerWidth,this.maxCellHeight=Math.max(o.size.outerHeight,this.maxCellHeight)}this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},p._sizeCells=function(t){t.forEach(function(t){t.getSize()})},p.updateSlides=function(){if(this.slides=[],this.cells.length){var n=new r(this);this.slides.push(n);var s="left"==this.originSide?"marginRight":"marginLeft",o=this._getCanCellFit();this.cells.forEach(function(t,e){if(n.cells.length){var i=n.outerWidth-n.firstMargin+(t.size.outerWidth-t.size[s]);o.call(this,e,i)||(n.updateTarget(),n=new r(this),this.slides.push(n)),n.addCell(t)}else n.addCell(t)},this),n.updateTarget(),this.updateSelectedSlide()}},p._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};if("number"==typeof t){var e=parseInt(t,10);return function(t){return t%e!=0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){return e<=(this.size.innerWidth+1)*n}},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=e(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var g={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return p.setCellAlign=function(){var t=g[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},p.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},p._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),t=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(t,0,1)}},p._getGapCells=function(t,e,i){for(var n=[];0<t;){var s=this.cells[e];if(!s)break;n.push(s),e+=i,t-=s.size.outerWidth}return n},p._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],s=n<this.size.innerWidth,o=this.cursorPosition+this.cells[0].size[e],r=n-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(function(t){s?t.target=n*this.cellAlign:(t.target=Math.max(t.target,o),t.target=Math.min(t.target,r))},this)}},p.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),l&&this.$element){var s=t+=this.options.namespaceJQueryEvents?".flickity":"";if(e){var o=l.Event(e);o.type=t,s=o}this.$element.trigger(s,i)}},p.select=function(t,e,i){if(this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=a.modulo(t,this.slides.length)),this.slides[t])){var n=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[t]),t!=n&&this.dispatchEvent("change",null,[t]),this.dispatchEvent("cellSelect")}},p._wrapSelect=function(t){var e=this.slides.length;if(!(this.options.wrapAround&&1<e))return t;var i=a.modulo(t,e),n=Math.abs(i-this.selectedIndex),s=Math.abs(i+e-this.selectedIndex),o=Math.abs(i-e-this.selectedIndex);!this.isDragSelect&&s<n?t+=e:!this.isDragSelect&&o<n&&(t-=e),t<0?this.x-=this.slideableWidth:e<=t&&(this.x+=this.slideableWidth)},p.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},p.next=function(t,e){this.select(this.selectedIndex+1,t,e)},p.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),(this.selectedSlide=t).select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectInitialIndex=function(){var t=this.options.initialIndex;if(this.isInitActivated)this.select(this.selectedIndex,!1,!0);else{if(t&&"string"==typeof t)if(this.queryCell(t))return void this.selectCell(t,!1,!0);var e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0)}},p.selectCell=function(t,e,i){var n=this.queryCell(t);if(n){var s=this.getCellSlideIndex(n);this.select(s,e,i)}},p.getCellSlideIndex=function(t){for(var e=0;e<this.slides.length;e++){if(-1!=this.slides[e].cells.indexOf(t))return e}},p.getCell=function(t){for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},p.getCells=function(t){t=a.makeArray(t);var i=[];return t.forEach(function(t){var e=this.getCell(t);e&&i.push(e)},this),i},p.getCellElements=function(){return this.cells.map(function(t){return t.element})},p.getParentCell=function(t){var e=this.getCell(t);return e||(t=a.getParent(t,".flickity-slider > *"),this.getCell(t))},p.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(i<=1+2*t)return this.getCellElements();for(var n=[],s=e-t;s<=e+t;s++){var o=this.options.wrapAround?a.modulo(s,i):s,r=this.slides[o];r&&(n=n.concat(r.getCellElements()))}return n},p.queryCell=function(t){if("number"==typeof t)return this.cells[t];if("string"==typeof t){if(t.match(/^[#\.]?[\d\/]/))return;t=this.element.querySelector(t)}return this.getCell(t)},p.uiChange=function(){this.emitEvent("uiChange")},p.childUIPointerDown=function(t){"touchstart"!=t.type&&t.preventDefault(),this.focus()},p.onresize=function(){this.watchCSS(),this.resize()},a.debounceMethod(f,"onresize",150),p.resize=function(){if(this.isActive){this.getSize(),this.options.wrapAround&&(this.x=a.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},p.watchCSS=function(){this.options.watchCSS&&(-1!=o(this.element,":after").content.indexOf("flickity")?this.activate():this.deactivate())},p.onkeydown=function(t){var e=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!e){var i=f.keyboardHandlers[t.keyCode];i&&i.call(this)}},f.keyboardHandlers={37:function(){var t=this.options.rightToLeft?"next":"previous";this.uiChange(),this[t]()},39:function(){var t=this.options.rightToLeft?"previous":"next";this.uiChange(),this[t]()}},p.focus=function(){var t=n.pageYOffset;this.element.focus({preventScroll:!0}),n.pageYOffset!=t&&n.scrollTo(n.pageXOffset,t)},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach(function(t){t.destroy()}),this.element.removeChild(this.viewport),c(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),n.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),l&&this.$element&&l.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete u[this.guid]},a.extend(p,s),f.data=function(t){var e=(t=a.getQueryElement(t))&&t.flickityGUID;return e&&u[e]},a.htmlInit(f,"flickity"),l&&l.bridget&&l.bridget("flickity",f),f.setJQuery=function(t){l=t},f.Cell=i,f.Slide=r,f}),function(e,i){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.Unipointer=i(e,e.EvEmitter)}(window,function(s,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindStartEvent=function(t){this._bindStartEvent(t,!0)},i.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},i._bindStartEvent=function(t,e){var i=(e=void 0===e||e)?"addEventListener":"removeEventListener",n="mousedown";s.PointerEvent?n="pointerdown":"ontouchstart"in s&&(n="touchstart"),t[i](n,this)},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},i.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},i.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},i.onpointerdown=function(t){this._pointerDown(t,t)},i._pointerDown=function(t,e){t.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},i.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var n={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return i._bindPostStartEvents=function(t){if(t){var e=n[t.type];e.forEach(function(t){s.addEventListener(t,this)},this),this._boundPointerEvents=e}},i._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach(function(t){s.removeEventListener(t,this)},this),delete this._boundPointerEvents)},i.onmousemove=function(t){this._pointerMove(t,t)},i.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},i.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},i._pointerMove=function(t,e){this.pointerMove(t,e)},i.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},i.onmouseup=function(t){this._pointerUp(t,t)},i.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},i.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},i._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},i._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},i._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},i.pointerDone=function(){},i.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},i.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},i._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},i.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},e.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},e}),function(e,i){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("unipointer")):e.Unidragger=i(e,e.Unipointer)}(window,function(o,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindHandles=function(){this._bindHandles(!0)},i.unbindHandles=function(){this._bindHandles(!1)},i._bindHandles=function(t){for(var e=(t=void 0===t||t)?"addEventListener":"removeEventListener",i=t?this._touchActionValue:"",n=0;n<this.handles.length;n++){var s=this.handles[n];this._bindStartEvent(s,t),s[e]("click",this),o.PointerEvent&&(s.style.touchAction=i)}},i._touchActionValue="none",i.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer=e,t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var s={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},r={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return i.okayPointerDown=function(t){var e=s[t.target.nodeName],i=r[t.target.type],n=!e||i;return n||this._pointerReset(),n},i.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},i.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},i._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},i.hasDragStarted=function(t){return 3<Math.abs(t.x)||3<Math.abs(t.y)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},i._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},i._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},i.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},i._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},i.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},i._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},i.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},i.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},i._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},i.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},e.getPointerPoint=t.getPointerPoint,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):n.Flickity=s(n,n.Flickity,n.Unidragger,n.fizzyUIUtils)}(window,function(i,t,e,a){a.extend(t.defaults,{draggable:">1",dragThreshold:3}),t.createMethods.push("_createDrag");var n=t.prototype;a.extend(n,e.prototype),n._touchActionValue="pan-y";var s="createTouch"in document,o=!1;n._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable),s&&!o&&(i.addEventListener("touchmove",function(){}),o=!0)},n.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},n.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},n.updateDraggable=function(){">1"==this.options.draggable?this.isDraggable=1<this.slides.length:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},n.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},n.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},n._uiChangeDrag=function(){delete this.isFreeScrolling},n.pointerDown=function(t,e){this.isDraggable?this.okayPointerDown(t)&&(this._pointerDownPreventDefault(t),this.pointerDownFocus(t),document.activeElement!=this.element&&this.pointerDownBlur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=l(),i.addEventListener("scroll",this),this._pointerDownDefault(t,e)):this._pointerDownDefault(t,e)},n._pointerDownDefault=function(t,e){this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},this._bindPostStartEvents(t),this.dispatchEvent("pointerDown",t,[e])};var r={INPUT:!0,TEXTAREA:!0,SELECT:!0};function l(){return{x:i.pageXOffset,y:i.pageYOffset}}return n.pointerDownFocus=function(t){r[t.target.nodeName]||this.focus()},n._pointerDownPreventDefault=function(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=r[t.target.nodeName];e||i||n||t.preventDefault()},n.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},n.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},n.pointerDone=function(){i.removeEventListener("scroll",this),delete this.pointerDownScroll},n.dragStart=function(t,e){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),i.removeEventListener("scroll",this),this.dispatchEvent("dragStart",t,[e]))},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},n.dragMove=function(t,e,i){if(this.isDraggable){t.preventDefault(),this.previousDragX=this.dragX;var n=this.options.rightToLeft?-1:1;this.options.wrapAround&&(i.x=i.x%this.slideableWidth);var s=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){var o=Math.max(-this.slides[0].target,this.dragStartPosition);s=o<s?.5*(s+o):s;var r=Math.min(-this.getLastSlide().target,this.dragStartPosition);s=s<r?.5*(s+r):s}this.dragX=s,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])}},n.dragEnd=function(t,e){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(i+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])}},n.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1);return i.distance<n.distance?i.index:n.index},n._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,s=1/0,o=this.options.contain&&!this.options.wrapAround?function(t,e){return t<=e}:function(t,e){return t<e};o(e,s)&&(n+=i,s=e,null!==(e=this.getSlideDistance(-t,n)));)e=Math.abs(e);return{distance:s,index:n-i}},n.getSlideDistance=function(t,e){var i=this.slides.length,n=this.options.wrapAround&&1<i,s=n?a.modulo(e,i):e,o=this.slides[s];if(!o)return null;var r=n?this.slideableWidth*Math.floor(e/i):0;return t-(o.target+r)},n.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||100<new Date-this.dragMoveTime)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return 0<t&&0<e?1:t<0&&e<0?-1:0},n.staticClick=function(t,e){var i=this.getParentCell(t.target),n=i&&i.element,s=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,s])},n.onscroll=function(){var t=l(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(3<Math.abs(e)||3<Math.abs(i))&&this._pointerDone()},t}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){"use strict";var s="http://www.w3.org/2000/svg";function o(t,e){this.direction=t,this.parent=e,this._create()}(o.prototype=Object.create(i.prototype))._create=function(){this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var i=this.createSVG();e.appendChild(i),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},o.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},o.prototype.deactivate=function(){this.parent.element.removeChild(this.element),this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},o.prototype.createSVG=function(){var t=document.createElementNS(s,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(s,"path"),i=function(t){return"string"!=typeof t?"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z":t}(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},o.prototype.handleEvent=n.handleEvent,o.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},o.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},o.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},o.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&1<t.length)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},o.prototype.destroy=function(){this.deactivate(),this.allOff()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var r=e.prototype;return r._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new o(-1,this),this.nextButton=new o(1,this),this.on("activate",this.activatePrevNextButtons))},r.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},r.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=o,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){function s(t){this.parent=t,this._create()}(s.prototype=Object.create(i.prototype))._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},s.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),this.parent.element.appendChild(this.holder)},s.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),this.parent.element.removeChild(this.holder)},s.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;0<t?this.addDots(t):t<0&&this.removeDots(-t)},s.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,s=n+t,o=n;o<s;o++){var r=document.createElement("li");r.className="dot",r.setAttribute("aria-label","Page dot "+(o+1)),e.appendChild(r),i.push(r)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},s.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach(function(t){this.holder.removeChild(t)},this)},s.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},s.prototype.onTap=s.prototype.onClick=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},s.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=s,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var o=e.prototype;return o._createPageDots=function(){this.options.pageDots&&(this.pageDots=new s(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},o.activatePageDots=function(){this.pageDots.activate()},o.updateSelectedPageDots=function(){this.pageDots.updateSelected()},o.updatePageDots=function(){this.pageDots.setDots()},o.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=s,e}),function(t,n){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],function(t,e,i){return n(t,e,i)}):"object"==typeof module&&module.exports?module.exports=n(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):n(t.EvEmitter,t.fizzyUIUtils,t.Flickity)}(window,function(t,e,i){function n(t){this.parent=t,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}(n.prototype=Object.create(t.prototype)).play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()))},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout(function(){e.parent.next(!0),e.tick()},t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var s=i.prototype;return s._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},s.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},s.playPlayer=function(){this.player.play()},s.stopPlayer=function(){this.player.stop()},s.pausePlayer=function(){this.player.pause()},s.unpausePlayer=function(){this.player.unpause()},s.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},s.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},s.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,n){var i=e.prototype;return i.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;e=void 0===e?n:e;var s=function(t){var e=document.createDocumentFragment();return t.forEach(function(t){e.appendChild(t.element)}),e}(i),o=e==n;if(o)this.slider.appendChild(s);else{var r=this.cells[e].element;this.slider.insertBefore(s,r)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},i.append=function(t){this.insert(t,this.cells.length)},i.prepend=function(t){this.insert(t,0)},i.remove=function(t){var e=this.getCells(t);if(e&&e.length){var i=this.cells.length-1;e.forEach(function(t){t.remove();var e=this.cells.indexOf(t);i=Math.min(e,i),n.removeFrom(this.cells,t)},this),this.cellChange(i,!0)}},i.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},i.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex),e&&this.positionSliderAtSelected()},e}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/lazyload",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,o){"use strict";e.createMethods.push("_createLazyload");var i=e.prototype;function s(t,e){this.img=t,this.flickity=e,this.load()}return i._createLazyload=function(){this.on("select",this.lazyLoad)},i.lazyLoad=function(){var t=this.options.lazyLoad;if(t){var e="number"==typeof t?t:0,i=this.getAdjacentCellElements(e),n=[];i.forEach(function(t){var e=function(t){if("IMG"==t.nodeName){var e=t.getAttribute("data-flickity-lazyload"),i=t.getAttribute("data-flickity-lazyload-src"),n=t.getAttribute("data-flickity-lazyload-srcset");if(e||i||n)return[t]}var s=t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");return o.makeArray(s)}(t);n=n.concat(e)}),n.forEach(function(t){new s(t,this)},this)}},s.prototype.handleEvent=o.handleEvent,s.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);var t=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),e=this.img.getAttribute("data-flickity-lazyload-srcset");this.img.src=t,e&&this.img.setAttribute("srcset",e),this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},s.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},s.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},s.prototype.complete=function(t,e){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},e.LazyLoader=s,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell","./lazyload"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell"),require("./lazyload")))}(window,function(t){return t}),function(t,e){"function"==typeof define&&define.amd?define("flickity-as-nav-for/as-nav-for",["flickity/js/index","fizzy-ui-utils/utils"],e):"object"==typeof module&&module.exports?module.exports=e(require("flickity"),require("fizzy-ui-utils")):t.Flickity=e(t.Flickity,t.fizzyUIUtils)}(window,function(n,s){n.createMethods.push("_createAsNavFor");var t=n.prototype;return t._createAsNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);var t=this.options.asNavFor;if(t){var e=this;setTimeout(function(){e.setNavCompanion(t)})}},t.setNavCompanion=function(t){t=s.getQueryElement(t);var e=n.data(t);if(e&&e!=this){this.navCompanion=e;var i=this;this.onNavCompanionSelect=function(){i.navCompanionSelect()},e.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0)}},t.navCompanionSelect=function(t){var e=this.navCompanion&&this.navCompanion.selectedCells;if(e){var i=e[0],n=this.navCompanion.cells.indexOf(i),s=n+e.length-1,o=Math.floor(function(t,e,i){return(e-t)*i+t}(n,s,this.navCompanion.cellAlign));if(this.selectCell(o,!1,t),this.removeNavSelectedElements(),!(o>=this.cells.length)){var r=this.cells.slice(n,1+s);this.navSelectedElements=r.map(function(t){return t.element}),this.changeNavSelectedClass("add")}}},t.changeNavSelectedClass=function(e){this.navSelectedElements.forEach(function(t){t.classList[e]("is-nav-selected")})},t.activateAsNavFor=function(){this.navCompanionSelect(!0)},t.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},t.onNavStaticClick=function(t,e,i,n){"number"==typeof n&&this.navCompanion.selectCell(n)},t.deactivateAsNavFor=function(){this.removeNavSelectedElements()},t.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},n}),function(e,i){"use strict";"function"==typeof define&&define.amd?define("imagesloaded/imagesloaded",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.imagesLoaded=i(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){var s=e.jQuery,o=e.console;function r(t,e){for(var i in e)t[i]=e[i];return t}var a=Array.prototype.slice;function l(t,e,i){if(!(this instanceof l))return new l(t,e,i);var n=t;"string"==typeof t&&(n=document.querySelectorAll(t)),n?(this.elements=function(t){return Array.isArray(t)?t:"object"==typeof t&&"number"==typeof t.length?a.call(t):[t]}(n),this.options=r({},this.options),"function"==typeof e?i=e:r(this.options,e),i&&this.on("always",i),this.getImages(),s&&(this.jqDeferred=new s.Deferred),setTimeout(this.check.bind(this))):o.error("Bad element for imagesLoaded "+(n||t))}(l.prototype=Object.create(t.prototype)).options={},l.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},l.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),!0===this.options.background&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&h[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var s=i[n];this.addImage(s)}if("string"==typeof this.options.background){var o=t.querySelectorAll(this.options.background);for(n=0;n<o.length;n++){var r=o[n];this.addElementBackgroundImages(r)}}}};var h={1:!0,9:!0,11:!0};function i(t){this.img=t}function n(t,e){this.url=t,this.element=e,this.img=new Image}return l.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var s=n&&n[2];s&&this.addBackground(s,t),n=i.exec(e.backgroundImage)}},l.prototype.addImage=function(t){var e=new i(t);this.images.push(e)},l.prototype.addBackground=function(t,e){var i=new n(t,e);this.images.push(i)},l.prototype.check=function(){var n=this;function e(t,e,i){setTimeout(function(){n.progress(t,e,i)})}this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?this.images.forEach(function(t){t.once("progress",e),t.check()}):this.complete()},l.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&o&&o.log("progress: "+i,t,e)},l.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},(i.prototype=Object.create(t.prototype)).check=function(){this.getIsImageComplete()?this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.proxyImage.src=this.img.src)},i.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},i.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},i.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},i.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},i.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},(n.prototype=Object.create(i.prototype)).check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url,this.getIsImageComplete()&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},n.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},n.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},l.makeJQueryPlugin=function(t){(t=t||e.jQuery)&&((s=t).fn.imagesLoaded=function(t,e){return new l(this,t,e).jqDeferred.promise(s(this))})},l.makeJQueryPlugin(),l}),function(i,n){"function"==typeof define&&define.amd?define(["flickity/js/index","imagesloaded/imagesloaded"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("flickity"),require("imagesloaded")):i.Flickity=n(i,i.Flickity,i.imagesLoaded)}(window,function(t,e,i){"use strict";e.createMethods.push("_createImagesLoaded");var n=e.prototype;return n._createImagesLoaded=function(){this.on("activate",this.imagesLoaded)},n.imagesLoaded=function(){if(this.options.imagesLoaded){var n=this;i(this.slider).on("progress",function(t,e){var i=n.getParentCell(e.img);n.cellSizeChange(i&&i.element),n.options.freeScroll||n.positionSliderAtSelected()})}},e});

("use strict");
var selectors = { disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]" },
    unitPriceSeparator = "/";
function onYouTubeIframeAPIReady() {
    Sunrise.Video.loadVideos(), Sunrise.ProductVideo.loadVideos(Sunrise.ProductVideo.hosts.youtube);
}
(Sunrise.Sections = function () {
    (this.constructors = {}),
        (this.instances = []),
        document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
        document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
        document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
        document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
        document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
        document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
}),
    (Sunrise.Sections.prototype = Object.assign({}, Sunrise.Sections.prototype, {
        _createInstance: function (e, t) {
            var i = e.getAttribute("data-section-id"),
                r = e.getAttribute("data-section-type");
            if (void 0 !== (t = t || this.constructors[r])) {
                var n = Object.assign(new t(e), { id: i, type: r, container: e });
                this.instances.push(n);
            }
        },
        _onSectionLoad: function (e) {
            var t = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
            t && this._createInstance(t);
        },
        _onSectionUnload: function (e) {
            this.instances = this.instances.filter(function (t) {
                var i = t.id === e.detail.sectionId;
                return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
            });
        },
        _onSelect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
            var t = this.instances.find(function (t) {
                return t.id === e.detail.sectionId;
            });
            void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        },
        register: function (e, t) {
            (this.constructors[e] = t),
                document.querySelectorAll('[data-section-type="' + e + '"]').forEach(
                    function (e) {
                        this._createInstance(e, t);
                    }.bind(this)
                );
        },
    })),
    (Sunrise.customerTemplates = (function () {
        function e() {
            document.querySelector("#recover-password-form").classList.toggle("hide"), document.querySelector("#customer-login-form").classList.toggle("hide");
        }
        return {
            init: function () {
                var t, i;
                !(function () {
                    var t = document.querySelector("#recover-password"),
                        i = document.querySelector("#hide-password-form");
                    t &&
                        t.addEventListener(
                            "click",
                            function (t) {
                                t.preventDefault(), e();
                            }.bind(this)
                        ),
                        i &&
                            i.addEventListener(
                                "click",
                                function (t) {
                                    t.preventDefault(), e();
                                }.bind(this)
                            );
                })(),
                    "#recover" === window.location.hash && e(),
                    (function () {
                        if (document.querySelector(".reset-password-success")) {
                            var e = document.getElementById("reset-success");
                            e.classList.remove("hide"), e.focus();
                        }
                    })(),
                    (t = document.getElementById("AddressNewForm")),
                    (i = document.getElementById("AddressNewButton")),
                    t &&
                        (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                        document.querySelectorAll(".address-country-option").forEach(function (e) {
                            var t = e.dataset.formId,
                                i = "AddressCountry_" + t,
                                r = "AddressProvince_" + t,
                                n = "AddressProvinceContainer_" + t;
                            new Shopify.CountryProvinceSelector(i, r, { hideElement: n });
                        }),
                        document.querySelectorAll(".address-new-toggle").forEach(function (e) {
                            e.addEventListener("click", function () {
                                var e = "true" === i.getAttribute("aria-expanded");
                                t.classList.toggle("hide"), i.setAttribute("aria-expanded", !e), i.focus();
                            });
                        }),
                        document.querySelectorAll(".address-edit-toggle").forEach(function (e) {
                            e.addEventListener("click", function (e) {
                                var t = e.target.dataset.formId,
                                    i = document.getElementById("EditFormButton_" + t),
                                    r = document.getElementById("EditAddress_" + t),
                                    n = "true" === i.getAttribute("aria-expanded");
                                r.classList.toggle("hide"), i.setAttribute("aria-expanded", !n), i.focus();
                            });
                        }),
                        document.querySelectorAll(".address-delete").forEach(function (e) {
                            e.addEventListener("click", function (e) {
                                var t = e.target.dataset.target,
                                    i = e.target.dataset.confirmMessage;
                                confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink(t, { parameters: { _method: "delete" } });
                            });
                        }));
            },
        };
    })()),
    (Sunrise.Images = {
        preload: function (e, t) {
            "string" == typeof e && (e = [e]);
            for (var i = 0; i < e.length; i++) {
                var r = e[i];
                this.loadImage(this.getSizedImageUrl(r, t));
            }
        },
        loadImage: function (e) {
            new Image().src = e;
        },
        switchImage: function (e, t, i) {
            var r = this.imageSize(t.src),
                n = this.getSizedImageUrl(e.src, r);
            i ? i(n, e, t) : (t.src = n);
        },
        imageSize: function (e) {
            var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return null !== t ? t[1] : null;
        },
        getSizedImageUrl: function (e, t) {
            if (null == t) return e;
            if ("master" === t) return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null != i) {
                var r = e.split(i[0]),
                    n = i[0];
                return this.removeProtocol(r[0] + "_" + t + n);
            }
            return null;
        },
        removeProtocol: function (e) {
            return e.replace(/http(s)?:/, "");
        },
    }),
    (Sunrise.rte = {
        wrapTable: function (e) {
            e.tables.forEach(function (t) {
                var i = document.createElement("div");
                i.classList.add(e.tableWrapperClass), t.parentNode.insertBefore(i, t), i.appendChild(t);
            });
        },
        wrapIframe: function (e) {
            e.iframes.forEach(function (t) {
                var i = document.createElement("div");
                i.classList.add(e.iframeWrapperClass), t.parentNode.insertBefore(i, t), i.appendChild(t), (t.src = t.src);
            });
        },
    }),
    (Sunrise.Helpers = (function () {
        var e = !1;
        function t(e, t) {
            (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.boxSizing = "border-box"),
                (e.style.height = e.offsetHeight + "px"),
                (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                window.setTimeout(function () {
                    (e.style.display = "none"),
                        e.style.removeProperty("height"),
                        e.style.removeProperty("padding-top"),
                        e.style.removeProperty("padding-bottom"),
                        e.style.removeProperty("margin-top"),
                        e.style.removeProperty("margin-bottom"),
                        e.style.removeProperty("overflow"),
                        e.style.removeProperty("transition-duration"),
                        e.style.removeProperty("transition-property");
                }, t);
        }
        function i(e, t) {
            e.style.removeProperty("display");
            var i = window.getComputedStyle(e).display;
            "none" === i && (i = "block"), (e.style.display = i);
            var r = e.offsetHeight;
            (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                (e.style.boxSizing = "border-box"),
                (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.height = r + "px"),
                e.style.removeProperty("padding-top"),
                e.style.removeProperty("padding-bottom"),
                e.style.removeProperty("margin-top"),
                e.style.removeProperty("margin-bottom"),
                window.setTimeout(function () {
                    e.style.removeProperty("height"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transition-property");
                }, t);
        }
        return {
            setTouch: function () {
                e = !0;
            },
            isTouch: function () {
                return e;
            },
            promiseStylesheet: function (e) {
                var t = e || window.theme.stylesheet;
                return (
                    void 0 === this.stylesheetPromise &&
                        (this.stylesheetPromise = new Promise(function (e) {
                            var i = document.querySelector('link[href="' + t + '"]');
                            i.loaded && e(),
                                i.addEventListener("load", function () {
                                    setTimeout(e, 0);
                                });
                        })),
                    this.stylesheetPromise
                );
            },
            triggerEvent: function (e, t) {
                var i = document.createEvent("HTMLEvents");
                i.initEvent(t, !1, !0), e.dispatchEvent(i);
            },
            debounce: function (e, t, i) {
                var r;
                return function () {
                    var n = this,
                        s = arguments,
                        o = function () {
                            (r = null), i || e.apply(n, s);
                        },
                        a = i && !r;
                    clearTimeout(r), (r = setTimeout(o, t)), a && e.apply(n, s);
                };
            },
            slideUp: t,
            slideDown: i,
            slideToggle: function (e, r) {
                return "none" === window.getComputedStyle(e).display ? i(e, r) : t(e, r);
            },
            enableScrollLock: function () {
                (scrollPosition = window.pageYOffset), (document.body.style.top = "-" + scrollPosition + "px"), document.body.classList.add(classes.preventScrolling);
            },
            disableScrollLock: function () {
                document.body.classList.remove(classes.preventScrolling), document.body.style.removeProperty("top"), window.scrollTo(0, scrollPosition);
            },
            prepareTransition: function (e) {
                e.addEventListener(
                    "transitionend",
                    function (e) {
                        e.currentTarget.classList.remove("is-transitioning");
                    },
                    { once: !0 }
                );
                var t = 0;
                ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"].forEach(function (i) {
                    var r = getComputedStyle(e)[i];
                    r && (r.replace(/\D/g, ""), t || (t = parseFloat(r)));
                }),
                    0 !== t && e.classList.add("is-transitioning");
            },
            trapFocus: function (e) {
                var t = document.querySelector(e),
                    i = t.querySelectorAll(
                        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
                    ),
                    r = i[0],
                    n = i[i.length - 1];
                t.addEventListener("keydown", function (e) {
                    ("Tab" === e.key || 9 === e.keyCode) && (e.shiftKey ? document.activeElement === r && (n.focus(), e.preventDefault()) : document.activeElement === n && (r.focus(), e.preventDefault()));
                });
            },
        };
    })()),
    (Sunrise.LibraryLoader = (function () {
        var e = "link",
            t = "script",
            i = "requested",
            r = "loaded",
            n = "https://cdn.shopify.com/shopifycloud/",
            s = {
                youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: t },
                plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: n + "shopify-plyr/v1.0/shopify-plyr.css", type: e },
                modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: e },
            };
        return {
            load: function (n, o) {
                var a = s[n];
                if (a && a.status !== i)
                    if (((o = o || function () {}), a.status !== r)) {
                        var c;
                        switch (((a.status = i), a.type)) {
                            case t:
                                c = (function (e, t) {
                                    var i = document.createElement("script");
                                    return (
                                        (i.src = e.src),
                                        i.addEventListener("load", function () {
                                            (e.status = r), t();
                                        }),
                                        i
                                    );
                                })(a, o);
                                break;
                            case e:
                                c = (function (e, t) {
                                    var i = document.createElement("link");
                                    return (
                                        (i.href = e.src),
                                        (i.rel = "stylesheet"),
                                        (i.type = "text/css"),
                                        i.addEventListener("load", function () {
                                            (e.status = r), t();
                                        }),
                                        i
                                    );
                                })(a, o);
                        }
                        (c.id = a.tagId), (a.element = c);
                        var l = document.getElementsByTagName(a.type)[0];
                        l.parentNode.insertBefore(c, l);
                    } else o();
            },
        };
    })()),
    (Sunrise.Video = (function () {
        var e = !1,
            t = !1,
            i = !1,
            r = !1,
            n = {},
            s = [],
            o = {
                ratio: 16 / 9,
                scrollAnimationDuration: 400,
                playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
                events: {
                    onReady: function (e) {
                        e.target.setPlaybackQuality("hd1080");
                        var t = D(e),
                            i = e.target.getVideoData().title;
                        P(), document.getElementById(t.id).setAttribute("tabindex", "-1"), W(), j(t.videoWrapper, i), "background" === t.type && (e.target.mute(), I(t.id));
                        t.videoWrapper.classList.add(d);
                    },
                    onStateChange: function (t) {
                        var i = D(t);
                        "background" !== i.status || U() || e || (t.data !== YT.PlayerState.PLAYING && t.data !== YT.PlayerState.BUFFERING) || (A(!0), (e = !0), i.videoWrapper.classList.remove(l));
                        switch (t.data) {
                            case YT.PlayerState.ENDED:
                                !(function (e) {
                                    switch (e.type) {
                                        case "background":
                                            s[e.id].seekTo(0);
                                            break;
                                        case "image_with_play":
                                            H(e.id), M(e.id, !1);
                                    }
                                })(i);
                                break;
                            case YT.PlayerState.PAUSED:
                                setTimeout(function () {
                                    t.target.getPlayerState() === YT.PlayerState.PAUSED && C(i);
                                }, 200);
                        }
                    },
                },
            },
            a = "video-is-playing",
            c = "video-is-paused",
            l = "video-is-loading",
            d = "video-is-loaded",
            u = "video-background-wrapper",
            h = "video--image_with_play",
            p = "video--background",
            m = "is-paused",
            f = "autoplay",
            y = "no-autoplay",
            v = "video-section-wrapper--min-height",
            g = ".video-section",
            S = ".video-section-wrapper",
            b = ".video-control__play",
            w = ".video-control__close-wrapper",
            L = ".video__pause",
            _ = ".video__pause-stop",
            E = ".video__pause-resume",
            q = ".icon__fallback-text";
        function k(e) {
            (t || i) && e && "function" == typeof s[e].playVideo && I(e);
        }
        function T(e) {
            s[e] && "function" == typeof s[e].pauseVideo && s[e].pauseVideo();
        }
        function I(t, r) {
            var o = n[t],
                a = s[t],
                c = o.videoWrapper;
            if (i) x(o);
            else {
                if (r || e) return c.classList.remove(l), x(o), void a.playVideo();
                a.playVideo();
            }
        }
        function A(t) {
            var r = t ? f : y;
            document.documentElement.classList.remove(f, y), document.documentElement.classList.add(r), t || (i = !0), (e = !0);
        }
        function P() {
            t || (U() && (i = !0), i && A(!1), (t = !0));
        }
        function x(e) {
            var t = e.videoWrapper,
                i = t.querySelector(L);
            t.classList.remove(l),
                i.classList.contains(m) && i.classList.remove(m),
                "background" !== e.status &&
                    (document.getElementById(e.id).setAttribute("tabindex", "0"),
                    "image_with_play" === e.type && (t.classList.remove(c), t.classList.add(a)),
                    setTimeout(function () {
                        t.querySelector(w).focus();
                    }, o.scrollAnimationDuration));
        }
        function C(e) {
            var t = e.videoWrapper;
            "image_with_play" === e.type && ("closed" === e.status ? t.classList.remove(c) : t.classList.add(c)), t.classList.remove(a);
        }
        function H(e) {
            var t = n[e],
                i = t.videoWrapper;
            switch ((document.getElementById(t.id).setAttribute("tabindex", "-1"), (t.status = "closed"), t.type)) {
                case "image_with_play":
                    s[e].stopVideo(), C(t);
                    break;
                case "background":
                    s[e].mute(),
                        (function (e) {
                            var t = document.getElementById(e);
                            t.classList.remove(h), t.classList.add(p), n[e].videoWrapper.classList.add(u), (n[e].status = "background"), B(t);
                        })(e);
            }
            i.classList.remove(c, a);
        }
        function D(e) {
            var t = e.target.getIframe().id;
            return n[t];
        }
        function M(e, t) {
            var i = n[e],
                r = i.videoWrapper.getBoundingClientRect().top + window.pageYOffset,
                s = i.videoWrapper.querySelector(b),
                a = 0,
                c = 0;
            if ((U() && i.videoWrapper.parentElement.classList.toggle("page-width", !t), t)) {
                if (
                    ((c = U() ? window.innerWidth / o.ratio : i.videoWrapper.offsetWidth / o.ratio),
                    (a = (window.innerHeight - c) / 2),
                    (i.videoWrapper.style.height = i.videoWrapper.getBoundingClientRect().height + "px"),
                    i.videoWrapper.classList.remove(v),
                    (i.videoWrapper.style.height = c + "px"),
                    !U() || !Shopify.designMode)
                ) {
                    var l = document.documentElement.style.scrollBehavior;
                    (document.documentElement.style.scrollBehavior = "smooth"), window.scrollTo({ top: r - a }), (document.documentElement.style.scrollBehavior = l);
                }
            } else {
                (c = U() ? i.videoWrapper.dataset.mobileHeight : i.videoWrapper.dataset.desktopHeight),
                    (i.videoWrapper.style.height = c + "px"),
                    setTimeout(function () {
                        i.videoWrapper.classList.add(v);
                    }, 600);
                var d = window.scrollX,
                    u = window.scrollY;
                s.focus(), window.scrollTo(d, u);
            }
        }
        function O(e) {
            var t = n[e];
            switch ((t.videoWrapper.classList.add(l), (t.videoWrapper.style.height = t.videoWrapper.offsetHeight + "px"), (t.status = "open"), t.type)) {
                case "image_with_play":
                    I(e, !0);
                    break;
                case "background":
                    !(function (e) {
                        var t = document.getElementById(e);
                        t.classList.remove(p),
                            t.classList.add(h),
                            setTimeout(function () {
                                document.getElementById(e).style.cssText = null;
                            }, 600),
                            n[e].videoWrapper.classList.remove(u),
                            n[e].videoWrapper.classList.add(a),
                            (n[e].status = "open");
                    })(e),
                        s[e].unMute(),
                        I(e, !0);
            }
            M(e, !0), document.addEventListener("keydown", V);
        }
        var V = function (e) {
            var t = document.activeElement.dataset.controls;
            27 === e.keyCode && t && (H(t), M(t, !1));
        };
        function W() {
            document.querySelectorAll("." + p).forEach(function (e) {
                B(e);
            });
        }
        function B(e) {
            if (r)
                if (U()) e.style.cssText = null;
                else {
                    var t = e.closest(S),
                        i = t.clientWidth,
                        n = e.clientWidth,
                        s = t.dataset.desktopHeight;
                    if (i / o.ratio < s) {
                        var a = "width: " + (n = Math.ceil(s * o.ratio)) + "px; height: " + s + "px; left: " + (i - n) / 2 + "px; top: 0;";
                        e.style.cssText = a;
                    } else {
                        var c = "width: " + i + "px; height: " + (s = Math.ceil(i / o.ratio)) + "px; top: " + (s - s) / 2 + "px; left: 0;";
                        e.style.cssText = c;
                    }
                    Sunrise.Helpers.prepareTransition(e), t.classList.add(d);
                }
        }
        function U() {
            return window.innerWidth < window.theme.breakpoints.medium;
        }
        var F = Sunrise.Helpers.debounce(function () {
                if (r) {
                    var e,
                        t = window.innerHeight === screen.height;
                    if ((W(), U())) {
                        for (e in n) n.hasOwnProperty(e) && (n[e].videoWrapper.classList.contains(a) && (t || (T(e), C(n[e]))), (n[e].videoWrapper.style.height = document.documentElement.clientWidth / o.ratio + "px"));
                        A(!1);
                    } else
                        for (e in (A(!0), n)) {
                            n[e].videoWrapper.querySelectorAll("." + h).length || (s[e].playVideo(), x(n[e]));
                        }
                }
            }, 200),
            z = Sunrise.Helpers.debounce(function () {
                if (r)
                    for (var e in n)
                        if (n.hasOwnProperty(e)) {
                            var t = n[e].videoWrapper,
                                i =
                                    t.getBoundingClientRect().top + window.pageYOffset + 0.75 * t.offsetHeight < window.pageYOffset ||
                                    t.getBoundingClientRect().top + window.pageYOffset + 0.25 * t.offsetHeight > window.pageYOffset + window.innerHeight;
                            if (t.classList.contains(a)) {
                                if (!i) return;
                                H(e), M(e, !1);
                            }
                        }
            }, 50);
        function N() {
            var e = document.querySelectorAll(b),
                t = document.querySelectorAll(w),
                i = document.querySelectorAll(L);
            e.forEach(function (e) {
                e.addEventListener("click", function (e) {
                    O(e.currentTarget.dataset.controls);
                });
            }),
                t.forEach(function (e) {
                    e.addEventListener("click", function (e) {
                        var t = e.currentTarget.dataset.controls;
                        e.currentTarget.blur(), H(t), M(t, !1);
                    });
                }),
                i.forEach(function (e) {
                    e.addEventListener("click", function (e) {
                        !(function (e) {
                            var t = n[e].videoWrapper.querySelector(L),
                                i = t.classList.contains(m);
                            i ? (t.classList.remove(m), k(e)) : (t.classList.add(m), T(e)), t.setAttribute("aria-pressed", !i);
                        })(e.currentTarget.dataset.controls);
                    });
                }),
                window.addEventListener("resize", F),
                window.addEventListener("scroll", z);
        }
        function R(e) {
            var t = Object.assign(o, n[e]);
            (t.playerVars.controls = t.controls), (s[e] = new YT.Player(e, t));
        }
        function j(e, t) {
            var i = e.querySelectorAll(b),
                r = e.querySelector(w),
                n = e.querySelector(L),
                s = r.querySelector(q),
                o = n.querySelector(_).querySelector(q),
                a = n.querySelector(E).querySelector(q);
            i.forEach(function (e) {
                var i = e.querySelector(q);
                i.textContent = i.textContent.replace("[video_title]", t);
            }),
                (s.textContent = s.textContent.replace("[video_title]", t)),
                (o.textContent = o.textContent.replace("[video_title]", t)),
                (a.textContent = a.textContent.replace("[video_title]", t));
        }
        return {
            init: function (e) {
                if (e) {
                    if (
                        ((n[e.id] = {
                            id: e.id,
                            videoId: e.dataset.id,
                            type: e.dataset.type,
                            status: "image_with_play" === e.dataset.type ? "closed" : "background",
                            video: e,
                            videoWrapper: e.closest(S),
                            section: e.closest(g),
                            controls: "background" === e.dataset.type ? 0 : 1,
                        }),
                        !r)
                    ) {
                        var t = document.createElement("script");
                        t.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(t, i);
                    }
                    P();
                }
            },
            editorLoadVideo: function (e) {
                r && (R(e), N());
            },
            loadVideos: function () {
                for (var e in n) n.hasOwnProperty(e) && R(e);
                N(), (r = !0);
            },
            playVideo: k,
            pauseVideo: T,
            removeEvents: function () {
                document.removeEventListener("keydown", V), window.removeEventListener("resize", F), window.removeEventListener("scroll", z);
            },
        };
    })()),
    (Sunrise.ProductVideo = (function () {
        var e = {},
            t = { html5: "html5", youtube: "youtube" },
            i = "[data-product-single-media-wrapper]",
            r = "enable-video-looping",
            n = "video-id";
        function s(i) {
            i
                ? (function () {
                      for (var i in e)
                          if (e.hasOwnProperty(i)) {
                              var r = e[i];
                              if (r.nativeVideo) continue;
                              r.host === t.html5 && (r.element.setAttribute("controls", "controls"), (r.nativeVideo = !0));
                          }
                  })()
                : c(t.html5);
        }
        function o() {
            window.YT.Player && c(t.youtube);
        }
        function a(e) {
            return "VIDEO" === e.tagName ? t.html5 : "IFRAME" === e.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e.src) ? t.youtube : null;
        }
        function c(t) {
            for (var i in e)
                if (e.hasOwnProperty(i)) {
                    var r = e[i];
                    r.host === t && r.ready();
                }
        }
        return {
            init: function (c, l) {
                if (c) {
                    var d = c.querySelector("iframe, video");
                    if (d) {
                        var u = c.getAttribute("data-media-id");
                        switch (
                            ((e[u] = {
                                mediaId: u,
                                sectionId: l,
                                host: a(d),
                                container: c,
                                element: d,
                                ready: function () {
                                    !(function (e) {
                                        if (e.player) return;
                                        var s = e.container.closest(i),
                                            o = s.getAttribute("data-" + r);
                                        switch (e.host) {
                                            case t.html5:
                                                e.player = new Shopify.Plyr(e.element, { loop: { active: o } });
                                                break;
                                            case t.youtube:
                                                var a = s.getAttribute("data-" + n);
                                                e.player = new YT.Player(e.element, {
                                                    videoId: a,
                                                    events: {
                                                        onStateChange: function (e) {
                                                            0 === e.data && o && e.target.seekTo(0);
                                                        },
                                                    },
                                                });
                                        }
                                        var c = function () {
                                            e.player && (e.host === t.html5 && e.player.pause(), e.host === t.youtube && e.player.pauseVideo && e.player.pauseVideo());
                                        };
                                        s.addEventListener("mediaHidden", c),
                                            s.addEventListener("xrLaunch", c),
                                            s.addEventListener("mediaVisible", function () {
                                                Sunrise.Helpers.isTouch() || (e.player && (e.host === t.html5 && e.player.play(), e.host === t.youtube && e.player.playVideo && e.player.playVideo()));
                                            });
                                    })(this);
                                },
                            }),
                            e[u].host)
                        ) {
                            case t.html5:
                                window.Shopify.loadFeatures([{ name: "video-ui", version: "1.0", onLoad: s }]), Sunrise.LibraryLoader.load("plyrShopifyStyles");
                                break;
                            case t.youtube:
                                Sunrise.LibraryLoader.load("youtubeSdk", o);
                        }
                    }
                }
            },
            hosts: t,
            loadVideos: c,
            removeSectionVideos: function (t) {
                for (var i in e)
                    if (e.hasOwnProperty(i)) {
                        var r = e[i];
                        r.sectionId === t && (r.player && r.player.destroy(), delete e[i]);
                    }
            },
        };
    })()),
    (Sunrise.ProductModel = (function () {
        var e = {},
            t = {},
            i = {},
            r = "[data-product-single-media-group]",
            n = "[data-shopify-xr]";
        function s(t) {
            if (!t)
                if (window.ShopifyXR) {
                    for (var i in e)
                        if (e.hasOwnProperty(i)) {
                            var r = e[i];
                            if (r.loaded) continue;
                            var n = document.querySelector("#ModelJson-" + i);
                            window.ShopifyXR.addModels(JSON.parse(n.innerHTML)), (r.loaded = !0);
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        s();
                    });
        }
        function o(e) {
            if (!e)
                for (var i in t)
                    if (t.hasOwnProperty(i)) {
                        var r = t[i];
                        r.modelViewerUi || (r.modelViewerUi = new Shopify.ModelViewerUI(r.element)), a(r);
                    }
        }
        function a(e) {
            var t = i[e.sectionId];
            e.container.addEventListener("mediaVisible", function () {
                t.element.setAttribute("data-shopify-model3d-id", e.modelId), Sunrise.Helpers.isTouch() || e.modelViewerUi.play();
            }),
                e.container.addEventListener("mediaHidden", function () {
                    t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
                }),
                e.container.addEventListener("xrLaunch", function () {
                    e.modelViewerUi.pause();
                });
        }
        return {
            init: function (a, c) {
                (e[c] = { loaded: !1 }),
                    a.forEach(function (e, s) {
                        var o = e.getAttribute("data-media-id"),
                            a = e.querySelector("model-viewer"),
                            l = a.getAttribute("data-model-id");
                        if (0 === s) {
                            var d = e.closest(r).querySelector(n);
                            i[c] = { element: d, defaultId: l };
                        }
                        t[o] = { modelId: l, sectionId: c, container: e, element: a };
                    }),
                    window.Shopify.loadFeatures([
                        { name: "shopify-xr", version: "1.0", onLoad: s },
                        { name: "model-viewer-ui", version: "1.0", onLoad: o },
                    ]),
                    Sunrise.LibraryLoader.load("modelViewerUiStyles");
            },
            removeSectionModels: function (i) {
                for (var r in t) {
                    if (t.hasOwnProperty(r)) t[r].sectionId === i && (t[r].modelViewerUi.destroy(), delete t[r]);
                }
                delete e[i];
            },
        };
    })()),
    (Sunrise.Disclosure = (function () {
        var e = "[data-disclosure-form]",
            t = "[data-disclosure-list]",
            i = "[data-disclosure-toggle]",
            r = "[data-disclosure-input]",
            n = "[data-disclosure-option]",
            s = "disclosure-list--visible";
        function o(e) {
            (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        return (
            (o.prototype = Object.assign({}, o.prototype, {
                _cacheSelectors: function () {
                    this.cache = {
                        disclosureForm: this.container.closest(e),
                        disclosureList: this.container.querySelector(t),
                        disclosureToggle: this.container.querySelector(i),
                        disclosureInput: this.container.querySelector(r),
                        disclosureOptions: this.container.querySelectorAll(n),
                    };
                },
                _setupListeners: function () {
                    (this.eventHandlers = this._setupEventHandlers()),
                        this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (e) {
                            e.addEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                },
                _setupEventHandlers: function () {
                    return {
                        connectOptions: this._connectOptions.bind(this),
                        toggleList: this._toggleList.bind(this),
                        onBodyClick: this._onBodyClick.bind(this),
                        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                    };
                },
                _connectOptions: function (e) {
                    e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                },
                _onDisclosureToggleFocusOut: function (e) {
                    !1 === this.container.contains(e.relatedTarget) && this._hideList();
                },
                _onDisclosureListFocusOut: function (e) {
                    var t = e.currentTarget.contains(e.relatedTarget);
                    this.cache.disclosureList.classList.contains(s) && !t && this._hideList();
                },
                _onDisclosureKeyUp: function (e) {
                    27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus());
                },
                _onBodyClick: function (e) {
                    var t = this.container.contains(e.target);
                    this.cache.disclosureList.classList.contains(s) && !t && this._hideList();
                },
                _submitForm: function (e) {
                    (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                },
                _hideList: function () {
                    this.cache.disclosureList.classList.remove(s), this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                },
                _toggleList: function () {
                    var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                    this.cache.disclosureList.classList.toggle(s), this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
                },
                destroy: function () {
                    this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                        this.cache.disclosureOptions.forEach(function (e) {
                            e.removeEventListener("click", this.eventHandlers.connectOptions);
                        }, this),
                        this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                        this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut),
                        this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut),
                        document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                },
            })),
            o
        );
    })()),
    (Sunrise.Currency = (function () {
        var e = Sunrise.strings.money_format;
        return {
            formatMoney: function (t, i) {
                "string" == typeof t && (t = t.replace(".", ""));
                var r = "",
                    n = /\{\{\s*(\w+)\s*\}\}/,
                    s = i || e;
                function o(e, t, i, r) {
                    if (((i = i || ","), (r = r || "."), isNaN(e) || null === e)) return 0;
                    var n = (e = (e / 100).toFixed(t)).split(".");
                    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "");
                }
                switch (s.match(n)[1]) {
                    case "amount":
                        r = o(t, 2);
                        break;
                    case "amount_no_decimals":
                        r = o(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        r = o(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        r = o(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        r = o(t, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        r = o(t, 2, "'");
                }
                return s.replace(n, r);
            },
        };
    })()),
    (Sunrise.Variants = (function () {
        function e(e) {
            (this.container = e.container),
                (this.product = e.product),
                (this.originalSelectorId = e.originalSelectorId),
                (this.enableHistoryState = e.enableHistoryState),
                (this.singleOptions = this.container.querySelectorAll(e.singleOptionSelector)),
                (this.currentVariant = this._getVariantFromOptions()),
                this.singleOptions.forEach(
                    function (e) {
                        e.addEventListener("change", this._onSelectChange.bind(this));
                    }.bind(this)
                );
        }
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                _getCurrentOptions: function () {
                    var e = [];
                    return (
                        this.singleOptions.forEach(function (t) {
                            var i = t.getAttribute("type");
                            (("radio" === i || "checkbox" === i) && !t.checked) || e.push({ value: t.value, index: t.getAttribute("data-index") });
                        }),
                        e
                    );
                },
                _getVariantFromOptions: function () {
                    var e = this._getCurrentOptions();
                    return this.product.variants.find(function (t) {
                        return e.every(function (e) {
                            return t[e.index] === e.value;
                        });
                    });
                },
                _onSelectChange: function () {
                    var e = this._getVariantFromOptions();
                    this.container.dispatchEvent(new CustomEvent("variantChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 })),
                        e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
                },
                _updateImages: function (e) {
                    var t = e.featured_image || {},
                        i = this.currentVariant.featured_image || {};
                    e.featured_image && t.src !== i.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 }));
                },
                _updateSKU: function (e) {
                    e.sku !== this.currentVariant.sku && this.container.dispatchEvent(new CustomEvent("variantSKUChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 }));
                },
                _updatePrice: function (e) {
                    (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) ||
                        this.container.dispatchEvent(new CustomEvent("variantPriceChange", { detail: { variant: e }, bubbles: !0, cancelable: !0 }));
                },
                _updateHistoryState: function (e) {
                    if (history.replaceState && e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({ path: t }, "", t);
                    }
                },
                _updateMasterSelect: function (e) {
                    var t = this.container.querySelector(this.originalSelectorId);
                    t && (t.value = e.id);
                },
            })),
            e
        );
    })()),
    (Sunrise.Product = (function () {
        function e(e) {
            this.container = e;
            var t = e.getAttribute("data-section-id");
            (this.zoomPictures = []),
                (this.selectors = {
                    originalSelectorId: "#productSelect-" + t,
                    addToCart: "#addToCart-" + t,
                    addToCartText: "#addToCartText-" + t,
                    priceContainer: "[data-price]",
                    productPrice: "[data-regular-price]",
                    comparePrice: "[data-sale-price]",
                    productSKU: "#productSKU-" + t,
                    productStockMsg: "#stockMsg-" + t,
                    singleOptionSelector: ".single-option-selector-" + t,
                    productThumbImages: ".product-single__thumbnail--" + t,
                    productFeaturedMedia: ".product-shot-" + t,
                    productThumbsWrapper: ".more-images-" + t,
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    productMediaTypeVideo: "[data-product-media-type-video]",
                    productMediaTypeModel: "[data-product-media-type-model]",
                    imageZoomWrapper: "[data-image-zoom-wrapper]",
                    smartPayWrap: ".extra-button-wrap-" + t,
                    unitPriceWrap: ".unit-price-wrap",
                }),
                (this.classes = { hidden: "hide", visibilityHidden: "visibility-hidden", jsZoomEnabled: "js-zoom-enabled", activeClass: "active-thumb" }),
                (this.settings = {
                    sectionId: t,
                    enableHistoryState: e.getAttribute("data-enable-history-state") || !1,
                    namespace: ".product-" + t,
                    showPreOrder: e.getAttribute("data-show-preorder"),
                    showInventory: e.getAttribute("data-show-inventory"),
                    zoomEnabled: !1,
                    imageSize: null,
                    imageZoomSize: null,
                    mediaQuery: "screen and (min-width: 799px)",
                });
            var i = document.getElementById("ProductJson-" + t);
            i && i.innerHTML.length && ((this.productSingleObject = JSON.parse(i.innerHTML)), (this.settings.imageSize = "1024x1024"), this.init());
        }
        function t(e, t) {
            void 0 !== e && Flickity.data(e).select(t);
        }
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                init: function () {
                    this.screenWidthChange(), this.initVariants(), this.initMoreImages(), this.initMediaSwitch(), this.initProductVideo(), this.initModelViewerLibraries(), this.initShopifyXrLaunch();
                },
                screenWidthChange: function () {
                    var e = this;
                    function t(t) {
                        t.matches ? e.initDesktopLayout() : e.initMobileLayout();
                    }
                    var i = window.matchMedia(this.settings.mediaQuery);
                    i.addListener(t), t(i);
                },
                initMobileLayout: function () {
                    var e = this.container.querySelectorAll(this.selectors.imageZoomWrapper);
                    e.length > 0 &&
                        e.forEach(
                            function (e, t) {
                                this.destroyZoom(t);
                            }.bind(this)
                        );
                },
                initDesktopLayout: function () {
                    var e = this.container.querySelectorAll(this.selectors.imageZoomWrapper);
                    e.length > 0 &&
                        e.forEach(
                            function (e, t) {
                                this.enableZoom(e, t);
                            }.bind(this)
                        );
                },
                initVariants: function () {
                    var e = {
                        container: this.container,
                        enableHistoryState: this.settings.enableHistoryState,
                        product: this.productSingleObject,
                        singleOptionSelector: this.selectors.singleOptionSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                    };
                    (this.variants = new Sunrise.Variants(e)),
                        this.container.addEventListener("variantChange", this.updateAddToCartButton.bind(this)),
                        this.container.addEventListener("variantImageChange", this.updateMedia.bind(this)),
                        this.container.addEventListener("variantPriceChange", this.updatePrices.bind(this)),
                        this.container.addEventListener("variantSKUChange", this.updateSKU.bind(this));
                },
                initMediaSwitch: function (e) {
                    if (this.container.querySelector(this.selectors.productThumbImages)) {
                        var i = this,
                            r = this.container.querySelector(this.selectors.productThumbsWrapper),
                            n = r.querySelectorAll(this.selectors.productThumbImages),
                            s = r.querySelector(".active-thumb");
                        r.classList.contains("flickity-enabled") && t(r, s.getAttribute("image-index")),
                            n.forEach(function (e) {
                                e.addEventListener("click", function (t) {
                                    t.preventDefault();
                                    var r = e.getAttribute("data-thumbnail-id");
                                    i.switchMedia(r), i.setActiveThumbnail(r);
                                });
                            });
                    }
                },
                // switchMedia: function (id) {
                // var current = this.container.querySelector(
                //     this.selectors.productMediaWrapper + ":not(.hide)"
                // );

                // if (current) {
                //     current.dispatchEvent(new CustomEvent("mediaHidden"));
                //     const oldVideo = current.querySelector("video");
                //     if (oldVideo) oldVideo.pause();
                // }

                // var next = this.container.querySelector(
                //     this.selectors.productMediaWrapper + "[data-media-id='" + id + "']"
                // );

                // next.classList.remove("hide");
                // next.dispatchEvent(new CustomEvent("mediaVisible"));
                // next.setAttribute("tabindex", "0");

                // const newVideo = next.querySelector("video");
                // if (newVideo) {
                //     newVideo.load();
                //     newVideo.play().catch(() => {});
                // }

                // this.container
                //     .querySelectorAll(
                //     this.selectors.productMediaWrapper + ":not([data-media-id='" + id + "'])"
                //     )
                //     .forEach(function (el) {
                //     el.classList.add("hide");
                //     el.setAttribute("tabindex", "-1");
                //     });
                // },
                switchMedia: function (id) {

                    var current = this.container.querySelector(
                        this.selectors.productMediaWrapper + ":not(.hide)"
                    );

                    if (current) {
                        current.dispatchEvent(new CustomEvent("mediaHidden"));

                        const oldVideo = current.querySelector("video");
                        if (oldVideo) {
                            oldVideo.pause();
                            oldVideo.currentTime = 0;
                        }
                    }

                    var next = this.container.querySelector(
                        this.selectors.productMediaWrapper + "[data-media-id='" + id + "']"
                    );

                    if (!next) return;

                    next.classList.remove("hide");
                    next.dispatchEvent(new CustomEvent("mediaVisible"));
                    next.setAttribute("tabindex", "0");

                    const newVideo = next.querySelector("video");

                    if (newVideo) {

                        // iOS autoplay safe setup
                        newVideo.muted = true;
                        newVideo.setAttribute("muted", "true");
                        newVideo.setAttribute("playsinline", "true");
                        newVideo.setAttribute("webkit-playsinline", "true");

                        newVideo.load();

                        // Important: wait till element visible
                        setTimeout(function () {
                            newVideo.play().catch(function(){});
                        }, 400);
                    }

                    this.container
                        .querySelectorAll(
                            this.selectors.productMediaWrapper + ":not([data-media-id='" + id + "'])"
                        )
                        .forEach(function (el) {
                            el.classList.add("hide");
                            el.setAttribute("tabindex", "-1");
                        });
                },
                setActiveThumbnail: function (e) {
                    if (void 0 === e) {
                        var i = this.container.querySelector(this.selectors.productMediaWrapper + ":not(.hide)");
                        if (!i) return;
                        e = i.getAttribute("data-thumbnail-id");
                    }
                    var r,
                        n = this.container.querySelectorAll(this.selectors.productThumbsWrapper);
                    document.querySelectorAll(this.selectors.productThumbImages).forEach(
                        function (e) {
                            e.classList.remove(this.classes.activeClass), e.removeAttribute("aria-current");
                        }.bind(this)
                    ),
                        n.forEach(
                            function (i) {
                                var n = i.querySelector(this.selectors.productThumbImages + "[data-thumbnail-id='" + e + "']");
                                n && ((r = n).classList.add(this.classes.activeClass), r.setAttribute("aria-current", !0), i.classList.contains("flickity-enabled") && t(i, r.getAttribute("data-image-index")));
                            }.bind(this)
                        );
                },
                updateMedia: function (e) {
                    var t = e.detail.variant.featured_media.id,
                        i = this.settings.sectionId + "-" + t;
                    this.switchMedia(i), this.setActiveThumbnail(i);
                },
                updateSKU: function (e) {
                    var t = e.detail.variant.sku || "",
                        i = document.querySelector(this.selectors.productSKU);
                    i && (t.trim().length < 1 ? ((i.innerHTML = ""), i.classList.add("hide")) : ((i.innerHTML = Sunrise.strings.sku + t), i.classList.remove("hide")));
                },
                updateAddToCartButton: function (e) {
                    var t = e.detail.variant,
                        i = document.querySelector(this.selectors.originalSelectorId),
                        r = document.querySelector(this.selectors.smartPayWrap),
                        n = document.querySelector(this.selectors.productStockMsg),
                        s = document.querySelector(this.selectors.addToCart),
                        o = s.querySelector(this.selectors.addToCartText);
                    if ((r && r.classList.add("hide"), n.classList.add("hide"), (n.innerHTML = ""), t))
                        if (t.available) {
                            var a = i.querySelector('[value="' + t.id + '"]'),
                                c = a.getAttribute("data-stk"),
                                l = a.getAttribute("data-policy");
                            r && r.classList.remove("hide"),
                                s.removeAttribute("disabled"),
                                (o.innerHTML = Sunrise.strings.add_to_cart),
                                "yes" == this.settings.showPreOrder && "shopify" == t.inventory_management && c <= 0 && "continue" == l
                                    ? ((n.innerHTML = "<div class='var-msg'>" + Sunrise.strings.preorder_msg + "</div>"), n.classList.remove("hide"))
                                    : "yes" == this.settings.showInventory &&
                                      "shopify" == t.inventory_management &&
                                      ((n.innerHTML = "<div class='var-msg'>" + Sunrise.strings.product_availability + " " + c + " " + Sunrise.strings.product_in_stock + "</div>"), n.classList.remove("hide"));
                        } else s.setAttribute("disabled", "disabled"), (o.innerHTML = Sunrise.strings.sold_out), r && r.classList.add("hide");
                    else s.setAttribute("disabled", "disabled"), (o.innerHTML = Sunrise.strings.unavailable), r && r.classList.add("hide");
                },
                updatePrices: function (e) {
                    var t = e.detail.variant,
                        i = this.container.querySelector(this.selectors.priceContainer),
                        r = i.querySelector(this.selectors.comparePrice),
                        n = i.querySelector(this.selectors.unitPriceWrap),
                        s = i.querySelector(this.selectors.productPrice);
                    if ((r && r.classList.add("hide"), n && n.classList.add("hide"), t)) {
                        var o = Sunrise.Currency.formatMoney(t.price, Sunrise.strings.money_format);
                        if (
                            ((s.innerHTML = "<span class=price-money>" + o + "</span>"),
                            r &&
                                (t.compare_at_price > t.price
                                    ? ((r.innerHTML = "<span class=price-money>" + Sunrise.Currency.formatMoney(t.compare_at_price, Sunrise.strings.money_format) + "</span>"), r.classList.remove("hide"))
                                    : r.classList.add("hide")),
                            n && t.unit_price)
                        ) {
                            var a = Sunrise.Currency.formatMoney(t.unit_price, Sunrise.strings.money_format) + unitPriceSeparator + this.getBaseUnit(t);
                            (n.innerHTML = a), n.classList.remove("hide");
                        }
                    }
                },
                getBaseUnit: function (e) {
                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                },
                // initProductVideo: function () {
                //     var e = this.settings.sectionId;

                //     this.container.querySelectorAll(this.selectors.productMediaTypeVideo).forEach(function (t) {
                //         Sunrise.ProductVideo.init(t, e);

                //         var video = t.querySelector("video");
                //         if (video && !t.classList.contains("hide")) {
                //         video.load();
                //         video.play().catch(() => {});
                //         }
                //     });
                // },
                initProductVideo: function () {

                    var sectionId = this.settings.sectionId;

                    this.container
                        .querySelectorAll(this.selectors.productMediaTypeVideo)
                        .forEach(function (wrapper) {

                            Sunrise.ProductVideo.init(wrapper, sectionId);

                            var video = wrapper.querySelector("video");

                            if (video) {

                                video.muted = true;
                                video.setAttribute("muted", "true");
                                video.setAttribute("playsinline", "true");
                                video.setAttribute("webkit-playsinline", "true");
                                video.setAttribute("preload", "auto");

                                if (!wrapper.classList.contains("hide")) {
                                    setTimeout(function () {
                                        video.play().catch(function(){});
                                    }, 400);
                                }
                            }
                        });
                },


                initModelViewerLibraries: function () {
                    var e = this.container.querySelectorAll(this.selectors.productMediaTypeModel);
                    e.length < 1 || Sunrise.ProductModel.init(e, this.settings.sectionId);
                },
                initShopifyXrLaunch: function () {
                    var e = this;
                    document.addEventListener("shopify_xr_launch", function (t) {
                        e.container.querySelector(e.selectors.productMediaWrapper + ":not(." + e.classes.hidden + ")").dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                    });
                },
                initMoreImages: function () {
                    var wrapper = this.container.querySelector(this.selectors.productThumbsWrapper);
                    if (!wrapper) return;

                    var flkty = new Flickity(wrapper, {
                        selector: ".product-image-small",
                        prevNextButtons: !0,
                        pageDots: !1,
                        freeScroll: !0,
                        wrapAround: !0,
                        autoPlay: !1,
                        cellAlign: "left",
                        contain: !0,
                        watchCSS: !0,
                        imagesLoaded: !0
                    });

                    flkty.on("ready", () => {
                        this.initProductVideo();
                    });
                },
                enableZoom: function (e, t) {
                    this.zoomPictures[t] = new Sunrise.Zoom(e);
                },
                destroyZoom: function (e) {
                    0 !== this.zoomPictures.length && this.zoomPictures[e].unload();
                },
            })),
            e
        );
    })()),
    (Sunrise.Zoom = (function () {
        var e = "[data-image-zoom]",
            t = "zoomImg",
            i = "data-image-zoom-target";
        function r(e) {
            (this.container = e), (this.cache = {}), (this.url = e.dataset.zoom), this._cacheSelectors(), this.cache.sourceImage && this._duplicateImage();
        }
        return (
            (r.prototype = Object.assign({}, r.prototype, {
                _cacheSelectors: function () {
                    this.cache = { sourceImage: this.container.querySelector(e) };
                },
                _init: function () {
                    var e = this.cache.targetImage.width,
                        t = this.cache.targetImage.height;
                    this.cache.sourceImage === this.cache.targetImage ? ((this.sourceWidth = e), (this.sourceHeight = t)) : ((this.sourceWidth = this.cache.sourceImage.width), (this.sourceHeight = this.cache.sourceImage.height)),
                        (this.xRatio = (this.cache.sourceImage.width - e) / this.sourceWidth),
                        (this.yRatio = (this.cache.sourceImage.height - t) / this.sourceHeight);
                },
                _start: function (e) {
                    this._init(), this._move(e);
                },
                _stop: function () {
                    this.cache.targetImage.style.opacity = 0;
                },
                _setTopLeftMaxValues: function (e, t) {
                    return { left: Math.max(Math.min(t, this.sourceWidth), 0), top: Math.max(Math.min(e, this.sourceHeight), 0) };
                },
                _move: function (e) {
                    var t = e.pageX - (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX),
                        i = e.pageY - (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY),
                        r = this._setTopLeftMaxValues(i, t);
                    (i = r.top), (t = r.left), (this.cache.targetImage.style.left = -t * -this.xRatio + "px"), (this.cache.targetImage.style.top = -i * -this.yRatio + "px"), (this.cache.targetImage.style.opacity = 1);
                },
                _duplicateImage: function () {
                    this._loadImage()
                        .then(
                            function (e) {
                                (this.cache.targetImage = e),
                                    (e.style.width = e.width + "px"),
                                    (e.style.height = e.height + "px"),
                                    (e.style.position = "absolute"),
                                    (e.style.maxWidth = "none"),
                                    (e.style.maxHeight = "none"),
                                    (e.style.opacity = 0),
                                    (e.style.border = "none"),
                                    (e.style.left = 0),
                                    (e.style.top = 0),
                                    this.container.appendChild(e),
                                    this._init(),
                                    (this._start = this._start.bind(this)),
                                    (this._stop = this._stop.bind(this)),
                                    (this._move = this._move.bind(this)),
                                    this.container.addEventListener("mouseenter", this._start),
                                    this.container.addEventListener("mouseleave", this._stop),
                                    this.container.addEventListener("mousemove", this._move),
                                    (this.container.style.position = "relative"),
                                    (this.container.style.overflow = "hidden");
                            }.bind(this)
                        )
                        .catch(function (e) {
                            console.warn("Error fetching image", e);
                        });
                },
                _loadImage: function () {
                    return new Promise(
                        function (e, r) {
                            var n = new Image();
                            n.setAttribute("role", "presentation"),
                                n.setAttribute(i, !0),
                                n.classList.add(t),
                                (n.src = this.url),
                                n.addEventListener("load", function () {
                                    e(n);
                                }),
                                n.addEventListener("error", function (e) {
                                    r(e);
                                });
                        }.bind(this)
                    );
                },
                unload: function () {
                    var e = this.container.querySelector("[" + i + "]");
                    e && e.remove(), this.container.removeEventListener("mouseenter", this._start), this.container.removeEventListener("mouseleave", this._stop), this.container.removeEventListener("mousemove", this._move);
                },
            })),
            r
        );
    })()),
    (Sunrise.sortHandler = function (e) {
        var t = "#sort-by",
            i = document.querySelector(t),
            r = i.getAttribute("data-default-sort");
        if (((Shopify.queryParams = {}), location.search.length))
            for (var n, s = 0, o = location.search.substr(1).split("&"); s < o.length; s++) (n = o[s].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(n[0])] = decodeURIComponent(n[1]));
        (i.value = r),
            document.addEventListener("change", function (e) {
                e.target.matches(t) &&
                    ((Shopify.queryParams.sort_by = i.value),
                    Shopify.queryParams.sort_by != r && (Shopify.queryParams.page && delete Shopify.queryParams.page, (location.search = decodeURIComponent(new URLSearchParams(Object.entries(Shopify.queryParams)).toString()))));
            });
    }),
    (Sunrise.initAccordions = function () {
        document.querySelectorAll(".gt-accordion h4").forEach(function (e) {
            var t = !1;
            e.addEventListener("click", function (e) {
                var i = e.target.nextElementSibling;
                i && ((t = !t), Sunrise.Helpers.slideToggle(i, 300), e.target.classList.toggle("active", t), e.target.setAttribute("aria-expanded", t));
            });
        });
    }),
    (Sunrise.Sidebar = function () {
        var e = "#sidebar",
            t = "nav.top-menu",
            i = document.querySelector(e),
            r = document.querySelector(t),
            n = i.getAttribute("data-keep-open"),
            s = i.getAttribute("data-menuchosen");
        if (r) {
            var o = r.getAttribute("data-menuchosen"),
                a = i.querySelector(".side-menu-mobile");
            if (
                (i.querySelectorAll("li.from-top-menu").forEach(function (e) {
                    return e.remove();
                }),
                s !== o)
            )
                r.querySelector("ul")
                    .cloneNode(!0)
                    .querySelectorAll("li.from-top-menu")
                    .forEach(function (e) {
                        a.appendChild(e);
                    });
        }
        n &&
            "/" != window.location.pathname &&
            (i.querySelectorAll("li.original-li").forEach(function (e) {
                e.querySelector(".active") && e.querySelector(".dropdown-toggle").click();
            }),
            i.querySelectorAll("li.active > a .dropdown-toggle").forEach(function (e) {
                return e.setAttribute("aria-expanded", !0);
            }));
    }),
    (Sunrise.Slideshow = (function () {
        var e,
            t,
            i = "[data-slider]";
        function r(r) {
            if (((this.container = r), (e = this.container.querySelector(i)))) {
                var n = parseInt(e.dataset.count, 10),
                    s = !1,
                    o = !1;
              
                "true" === e.dataset.autoplay && (o = e.dataset.speed),
                    n > 1 && (s = !0),
                  console.log(o);
                  var autoplaySpeed = parseInt(e.getAttribute('data-speed'), 10);
              console.log(autoplaySpeed);
                    (t = new Flickity(e, { selector: ".slide", prevNextButtons: s, pageDots: s, freeScroll: !1, wrapAround: !0, autoPlay: true, autoPlay: autoplaySpeed, cellAlign: "left", contain: !0, adaptiveHeight: !1, imagesLoaded: !0 })),
                    e.querySelectorAll(".slide").forEach(function (e) {
                        return e.classList.remove("is-hidden");
                    });
            }
        }
        return (
            (r.prototype = Object.assign({}, r.prototype, {
                onDeselect: function (e) {
                    t.autoPlay && t.playPlayer();
                },
                onBlockSelect: function (e) {
                    t.stopPlayer(), t.select(e.target.dataset.index);
                },
                onBlockDeselect: function (e) {
                    this.onDeselect(e);
                },
            })),
            r
        );
    })()),
    (Sunrise.LogoList = (function () {
        var e,
            t,
            i,
            r = "[data-slider]";
        function n(n) {
            if (((this.container = n), (e = this.container.querySelector(r)))) {
                i = parseInt(e.dataset.count, 10);
                var s = !1;
                "false" != e.dataset.autoplay && (s = e.dataset.autoplay);
                var o = { selector: ".logo-list-item", prevNextButtons: !0, pageDots: !1, freeScroll: !0, wrapAround: !0, autoPlay: s, cellAlign: "left", contain: !0, adaptiveHeight: !0, imagesLoaded: !0 };
                i > 5 && (e.classList.remove("is-static"), (t = new Flickity(e, o))),
                    e.querySelectorAll(".logo-list-item").forEach(function (e) {
                        return e.classList.remove("is-hidden");
                    });
            }
        }
        return (
            (n.prototype = Object.assign({}, n.prototype, {
                onDeselect: function (e, t) {
                    t && i > 5 && 0 != t.options.autoPlay && t.playPlayer();
                },
                onBlockSelect: function (e) {
                    t.stopPlayer(), t.select(e.target.dataset.index);
                },
                onBlockDeselect: function (e) {
                    this.onDeselect(e, t);
                },
            })),
            n
        );
    })()),
    (Sunrise.FeaturedVideo = void 0),
    (Sunrise.Cart = (function () {
        var e = "#cartform";
        function t(t) {
            this.container = t;
            var i = this.container.querySelector(e),
                r = i.querySelectorAll("input.quantity"),
                n = !1;
            function s(e) {
                if ("shopify" != e.dataset.managed || "deny" != e.dataset.policy) return !1;
                var t = parseInt(e.dataset.stk, 10);
                return parseInt(e.value, 10) > t || void 0;
            }
            r.forEach(function (e) {
                s(e) && ((e.value = parseInt(e.dataset.stk, 10)), (n = !0));
            }),
                n && (alert(Sunrise.strings.cart_low_stock_message), i.querySelector(".cart-update").click()),
                r.forEach(function (e) {
                    e.addEventListener("blur", function (t) {
                        s(e) && ((e.value = parseInt(e.dataset.stk, 10)), alert(Sunrise.strings.stock_reduced_message + " " + e.value));
                    });
                }),
                window.Shopify.Cart && Shopify.Cart.ShippingCalculator.show();
        }
        return (t.prototype = Object.assign({}, t.prototype, { onUnload: function () {} })), t;
    })()),
    (Sunrise.Collection = (function () {
        function e(e) {
            this.container = e;
            var t = e.querySelector(".coll-tags");
            t && t.classList.remove("show-tags"), Sunrise.sortHandler();
        }
        return (e.prototype = Object.assign({}, e.prototype, { onUnload: function () {} })), e;
    })()),
    (Sunrise.FeaturedCollection = (function () {
        function e(e) {}
        return (e.prototype = Object.assign({}, e.prototype, { onUnload: function () {} })), e;
    })()),
    (Sunrise.Footer = (function () {
        function e(e) {
            (this.container = e),
                (this.cache = {}),
                this.cacheSelectors(),
                this.cache.localeDisclosure && (this.localeDisclosure = new Sunrise.Disclosure(this.cache.localeDisclosure)),
                this.cache.currencyDisclosure && (this.currencyDisclosure = new Sunrise.Disclosure(this.cache.currencyDisclosure));
        }
        return (
            (e.prototype = Object.assign({}, e.prototype, {
                cacheSelectors: function () {
                    this.cache = { localeDisclosure: this.container.querySelector(selectors.disclosureLocale), currencyDisclosure: this.container.querySelector(selectors.disclosureCurrency) };
                },
                onDeselect: function (e) {},
                onUnload: function () {
                    Sunrise.Helpers.triggerEvent(window, "scroll"), this.cache.localeDisclosure && this.localeDisclosure.destroy(), this.cache.currencyDisclosure && this.currencyDisclosure.destroy();
                },
            })),
            e
        );
    })()),
    (Sunrise.Maps = (function () {
        var e = 14,
            t = null,
            i = [],
            r = { addressNoResults: Sunrise.strings.addressNoResults, addressQueryLimit: Sunrise.strings.addressQueryLimit, addressError: Sunrise.strings.addressError, authError: Sunrise.strings.authError },
            n = '[data-section-type="map"]',
            s = "[data-map]",
            o = "[data-map-overlay]",
            a = "map-section--load-error",
            c = "map-section__error errors text-center";
        function l(e) {
            (this.map = e.querySelector(s)),
                this.map &&
                    ((this.key = this.map.dataset.apiKey),
                    void 0 !== this.key &&
                        ("loaded" === t
                            ? this.createMap()
                            : (i.push(this),
                              "loading" !== t &&
                                  ((t = "loading"),
                                  void 0 === window.google &&
                                      Sunrise.Helpers.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                                          (t = "loaded"),
                                              i.forEach(function (e) {
                                                  e.createMap();
                                              });
                                      })))));
        }
        return (
            (window.gm_authFailure = function () {
                Shopify.designMode &&
                    (document.querySelector(n).classList.add(a), document.querySelector(s).remove(), document.querySelector(o).insertAdjacentHTML("afterend", '<div class="' + c + '">' + Sunrise.strings.authError + "</div>"));
            }),
            (l.prototype = Object.assign({}, l.prototype, {
                createMap: function () {
                    return ((t = this.map),
                    new Promise(function (e, i) {
                        var r = new google.maps.Geocoder(),
                            n = t.dataset.addressSetting;
                        r.geocode({ address: n }, function (t, r) {
                            r !== google.maps.GeocoderStatus.OK && i(r), e(t);
                        });
                    }))
                        .then(
                            function (t) {
                                var i = { zoom: e, center: t[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                    r = (this.map = new google.maps.Map(this.map, i)),
                                    n = (this.center = r.getCenter());
                                new google.maps.Marker({ map: r, position: r.getCenter() });
                                google.maps.event.addDomListener(
                                    window,
                                    "resize",
                                    Sunrise.Helpers.debounce(
                                        function () {
                                            google.maps.event.trigger(r, "resize"), r.setCenter(n), this.map.removeAttribute("style");
                                        }.bind(this),
                                        250
                                    )
                                );
                            }.bind(this)
                        )
                        .catch(
                            function () {
                                var e;
                                switch (status) {
                                    case "ZERO_RESULTS":
                                        e = r.addressNoResults;
                                        break;
                                    case "OVER_QUERY_LIMIT":
                                        e = r.addressQueryLimit;
                                        break;
                                    case "REQUEST_DENIED":
                                        e = r.authError;
                                        break;
                                    default:
                                        e = r.addressError;
                                }
                                Shopify.designMode && (this.map.parentNode.classList.add(a), (this.map.parentNode.innerHTML = '<div class="' + c + '">' + e + "</div>"));
                            }.bind(this)
                        );
                    var t;
                },
                onUnload: function () {
                    this.map && google.maps.event.clearListeners(this.map, "resize");
                },
            })),
            l
        );
    })()),
    (Sunrise.predictiveSearch = function () {
        var e = window.theme.settings.predictiveSearchEnabled,
            t = "[data-top-search-wrapper]",
            i = "[data-main-search-wrapper]",
            r = "[data-main-search-field]",
            n = "[data-top-search-field]",
            s = ".search-form-wrap",
            o = ".search-submit",
            a = ".search-form-clear",
            c = ".search-bar-close",
            l = 'input[name="q"]',
            d = ".predictive-search-wrapper",
            u = "ul.predictive-results",
            h = "li.search-result-single",
            p = "input-has-text",
            m = "is-fixed",
            f = "result-selected",
            y = "hide-results",
            v = "do-search",
            g = 27,
            S = 38,
            b = 40,
            w = JSON.parse(document.querySelector(t).getAttribute("data-translations"));
        function L(e) {
            e.preventDefault(), document.documentElement.classList.remove(m), document.body.classList.remove(m), (document.querySelector(t).style.display = "none");
        }
        function _(t) {
            if (e) {
                var i = t.closest(s),
                    r = t.value.trim(),
                    n = i.querySelector(o + " path"),
                    a = i.querySelector(d),
                    c = i.getAttribute("id") + "-",
                    l = 0,
                    h = "product",
                    m = "",
                    f = window.routes.searchUrl + "/suggest.json";
                if ("" === r) return i.classList.remove(p), void (a.innerHTML = "");
                n.classList.add("animated-looped-fast", "pulse"),
                    a.querySelector(u) || (a.innerHTML = "<ul id='" + c + "results' role='list' class='predictive-results'></ul>"),
                    "products" != window.theme.settings.predictiveSearchType && (h = "product,page,article,collection");
                fetch(f + "?q=" + r + "&resources[type]=" + h + "&resources[limit]=5&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor")
                    .then(function (e) {
                        return e.ok
                            ? e.json()
                            : e.json().then(function (e) {
                                  return Promise.reject(e);
                              });
                    })
                    .then(function (e) {
                        !(function (e) {
                            (m = ""), (l = 0), e.products && v(e.products, "products");
                            "product" != h && (e.collections.length && v(e.collections, "collections"), e.pages.length && v(e.pages, "pages"), e.articles.length && v(e.articles, "articles"));
                            var t =
                                '<li class="search-action search-result-single" role="listitem" data-index="' +
                                l +
                                '">\n        <a class="button do-search" href="/search?options%5Bprefix%5D=last&q=' +
                                r +
                                '">' +
                                w.searchfor +
                                '<span class="predictive-search-view-all__query"> ' +
                                r +
                                "</span></a></li>";
                            m += t;
                            var s = Sunrise.strings.one_result_found;
                            1 != l && (s = Sunrise.strings.number_of_results_found.replace("[results_count]", l));
                            (m = "<li aria-live='polite' role='status' class='visually-hidden search-results-count'>" + s + "</li>" + m),
                                (a.querySelector(u).innerHTML = m),
                                n.classList.remove("animated-looped-fast", "pulse"),
                                i.classList.add(p),
                                i.classList.remove(y),
                                i.setAttribute("data-resultcount", l);
                        })(e.resources.results);
                    })
                    .catch(function (e) {
                        console.log(e);
                    });
            }
            function v(e, t) {
                if (e.length) {
                    var i,
                        r,
                        n,
                        s,
                        o,
                        a,
                        d,
                        u = w[t];
                    (m += '<li class="search-category"><h4>' + u + "</h4></li>"),
                        e.forEach(function (e) {
                            if (((i = ""), e.hasOwnProperty("featured_image") && null != e.featured_image.url)) {
                                var t = Sunrise.Images.getSizedImageUrl(e.featured_image.url, "120x120");
                                i = '<div class="thumbnail"><img class="lazyload fade-in" src="' + t + '" /></div>';
                            }
                            (r = ""),
                                (n = ""),
                                (s = ""),
                                (a = ""),
                                "",
                                (o = ""),
                                window.theme.settings.predictiveSearchShowPrice &&
                                    null != e.price &&
                                    ((r = Sunrise.Currency.formatMoney(e.price, Sunrise.strings.money_format)),
                                    "0.00" != e.compare_at_price_min && ((o = Sunrise.Currency.formatMoney(e.compare_at_price_min, Sunrise.strings.money_format)), (n = '<del><span class="price-money">' + o + "</span></del>")),
                                    (s = '<span class="search-price"><span class="price-money">' + r + "</span>" + n + "</span>")),
                                window.theme.settings.predictiveSearchShowVendor && null != e.vendor && (a = '<span class="search-vendor">' + e.vendor + "</span>"),
                                (d = '<div class="search-result-column"><div class="search-item-title">' + (e.title + a) + "</div>" + s + "</div>"),
                                (m += '<li class="search-result-single" role="listitem" data-index="' + l + '"><a id="' + (c + l) + '" class="predictive-result" href="' + e.url + '">' + (i + d) + "</a></li>"),
                                l++;
                        });
                }
            }
        }
        var E = function (e) {
                var t, i;
                (t = e.target), (i = t.closest(s)), t.value.trim() ? (i.classList.add(p), t.setAttribute("aria-expanded", "true")) : (i.classList.remove(p), t.setAttribute("aria-expanded", "false"));
            },
            q = document.querySelector(r);
        q &&
            q.addEventListener(
                "input",
                Sunrise.Helpers.debounce(function (e) {
                    _(e.target);
                }, 200)
            );
        var k = document.querySelector(n);
        k &&
            k.addEventListener(
                "input",
                Sunrise.Helpers.debounce(function (e) {
                    _(e.target);
                }, 200)
            ),
            document.addEventListener("focusin", function (e) {
                var t;
                e.target.matches(r) && (t = e.target).value.trim() && (document.querySelector(i).classList.remove(y), _(t));
            }),
            document.addEventListener("click", function (e) {
                var r, o, u;
                e.target.matches(".menu-search") &&
                    ((r = e),
                    (o = document.querySelector(t)),
                    (u = o.querySelector(n)),
                    r.preventDefault(),
                    document.documentElement.classList.add(m),
                    document.body.classList.add(m),
                    Sunrise.Helpers.trapFocus(t),
                    (o.style.display = "block"),
                    u.focus(),
                    u.value.trim() ? (o.classList.add(p), _(u)) : o.classList.remove(p)),
                    e.target.matches(c) && L(e),
                    e.target.matches(a) &&
                        (function (e, t) {
                            e.preventDefault();
                            var i = t.closest(s);
                            i.classList.remove(p);
                            var r = i.querySelector(l);
                            (r.value = ""), r.focus(), (i.querySelector(d).innerHTML = "");
                        })(e, e.target),
                    e.target.closest(s) || (document.querySelector(i) && document.querySelector(i).classList.add(y));
            }),
            document.addEventListener("change", function (e) {
                e.target.matches(l) && E(e);
            }),
            document.addEventListener("paste", function (e) {
                e.target.matches(l) && E(e);
            }),
            document.addEventListener("keyup", function (e) {
                e.target.matches(l) && E(e);
            }),
            document.addEventListener("keydown", function (e) {
                e.target.matches(l) &&
                    (function (e, t) {
                        switch (e.keyCode) {
                            case b:
                                var i = t.closest(s).querySelector(u).querySelector(h);
                                i.classList.add(f);
                                var r = i.querySelector("a");
                                r && (r.classList.add(f), r.focus());
                                break;
                            case g:
                                L(e);
                                break;
                            default:
                        }
                    })(e, e.target),
                    (e.target.matches(".predictive-result") || e.target.matches(".do-search")) &&
                        (function (e, t) {
                            var i,
                                r,
                                n = t.closest(s),
                                o = n.querySelector(l),
                                a = t.closest(h),
                                c = a.getAttribute("data-index"),
                                d = parseInt(n.getAttribute("data-resultcount"), 10);
                            switch (e.keyCode) {
                                case b:
                                    if (c == d || t.classList.contains(v)) return;
                                    for (a.classList.remove(f), a.querySelector("a").classList.remove(f), c++, i = a.nextElementSibling; i && !i.matches(h); ) i = i.nextElementSibling;
                                    i.classList.add(f), (r = i.querySelector("a")).classList.add(f), r.focus();
                                    break;
                                case S:
                                    if (0 == c) return a.classList.remove(f), a.querySelector("a").classList.remove(f), void o.focus();
                                    for (a.classList.remove(f), a.querySelector("a").classList.remove(f), c--, i = a.previousElementSibling; i && !i.matches(h); ) i = i.previousElementSibling;
                                    i.classList.add(f), i.querySelector("a").classList.add(f), i.querySelector("a").focus();
                                    break;
                                case g:
                                    L(e);
                                    break;
                                default:
                            }
                        })(e, e.target),
                    document.querySelector(t) && e.keyCode == g && L(e);
            });
    }),
    (Sunrise.Quotes = (function () {
        var e,
            t,
            i = "[data-slider]",
            r = { cellAlign: "left", contain: !0, adaptiveHeight: !0, prevNextButtons: !1, autoPlay: 5e3 };
        function n(n) {
            (this.container = n), (e = this.container.querySelector(i)) && (e.dataset.count < 2 || (t = new Flickity(e, r)));
        }
        return (
            (n.prototype = Object.assign({}, n.prototype, {
                onDeselect: function (i) {
                    r.autoPlay > 0 && e.dataset.count > 1 && t.playPlayer();
                },
                onBlockSelect: function (e) {
                    t.stopPlayer(), t.select(e.target.dataset.index);
                },
                onBlockDeselect: function (e) {
                    this.onDeselect(e);
                },
            })),
            n
        );
    })()),
    (Sunrise.initSections = function () {
        var e = new Sunrise.Sections();
        e.register("slideshow", Sunrise.Slideshow),
            e.register("product", Sunrise.Product),
            e.register("sidebar", Sunrise.Sidebar),
            e.register("logo-list", Sunrise.LogoList),
            e.register("featured-video", Sunrise.FeaturedVideo),
            e.register("cart-template", Sunrise.Cart),
            e.register("collection-template", Sunrise.Collection),
            e.register("featured-collection", Sunrise.FeaturedCollection),
            e.register("quotes", Sunrise.Quotes),
            e.register("footer", Sunrise.Footer),
            e.register("map-section", Sunrise.Maps);
    }),
    (Sunrise.initListeners = function () {
        var e = document.documentElement;
        window.addEventListener(
            "resize",
            Sunrise.Helpers.debounce(function () {
                (window.innerWidth || document.documentElement.clientWidth) > 800
                    ? (document.body.classList.remove("small-screen"), document.body.classList.add("two-column"))
                    : (document.body.classList.add("small-screen"), document.body.classList.remove("two-column"));
            }, 200)
        ),
            window.addEventListener(
                "scroll",
                Sunrise.Helpers.debounce(function () {
                    var t = document.querySelector(".xx-scroll-to-top");
                    e.scrollTop > 200 ? (t.style.display = "block") : (t.style.display = "none");
                }, 200)
            ),
            document.addEventListener(
                "click",
                function (e) {
                    if (
                        (e.target.matches(".dropdown-toggle") &&
                            (function (e) {
                                e.preventDefault();
                                var t = e.target.parentNode.nextElementSibling,
                                    i = e.target.closest("li"),
                                    r = i.classList.contains("active");
                                (r = !r), Sunrise.Helpers.slideToggle(t, 300), i.classList.toggle("active", r), e.target.setAttribute("aria-expanded", r);
                            })(e),
                        e.target.matches(".menu-button") && (e.preventDefault(), document.body.classList.toggle("active-nav"), document.querySelector(".menu-button").classList.remove("active-button")),
                        e.target.matches("input[name='checkout']") || e.target.matches("input[name='goto_pp']") || e.target.matches("input[name='goto_gc']"))
                    ) {
                        var t = document.querySelector("#agree-terms");
                        if (t) t.querySelector("#agree").checked || (e.preventDefault(), alert(Sunrise.strings.agree_terms_popup_text), t.classList.add("highlight"), document.getElementById("agree").focus());
                    }
                    e.target.matches(".coll-tags .button") && (e.preventDefault(), Sunrise.Helpers.slideToggle(document.querySelector(".tags"), 300)),
                        e.target.matches("a.go-back") && (e.preventDefault(), (window.location.href = document.referrer)),
                        e.target.matches(".xx-scroll-to-top") && (e.preventDefault(), document.documentElement.scrollTo({ top: 0, behavior: "smooth" }));
                },
                !1
            ),
            document.addEventListener(
                "change",
                function (e) {
                    e.target.matches("#BlogTagFilter") && (e.preventDefault(), (window.location.href = e.target.value));
                },
                !1
            ),
            Sunrise.Helpers.triggerEvent(window, "resize"),
            Sunrise.Helpers.triggerEvent(window, "scroll");
    });
var ready = function (e) {
    "loading" != document.readyState ? e() : document.addEventListener("DOMContentLoaded", e);
};
(Sunrise.init = function () {
    Sunrise.initListeners(), Sunrise.initAccordions(), Sunrise.initSections(), Sunrise.customerTemplates.init(), Sunrise.predictiveSearch();
    Sunrise.rte.wrapTable({ tables: document.querySelectorAll(".rte table,.custom__item-inner--html table"), tableWrapperClass: "scrollable-wrapper" });
    Sunrise.rte.wrapIframe({
        iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),
        iframeWrapperClass: "video-wrapper",
    }),
        document.addEventListener(
            "touchstart",
            function () {
                Sunrise.Helpers.setTouch();
            },
            { once: !0 }
        );
}),
    ready(function () {
        Sunrise.init();
    });
